import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import { Config, TokenExpiration, TokenRenew } from './useConfigs.types';

export const useGetConfigs: BaseHookRequest<Config[], null> = params => {
  const [{ getRequest }, state] = useApi(params);
  const getConfigs = () => getRequest<Config[]>('/admin/config');
  return [getConfigs, state];
};

export const useUpdateConfigs: BaseHookRequest<Config[], Config> = params => {
  const [{ postRequest }, state] = useApi(params);
  const updateInterviewQuestions: BaseRequest<Config> = details => {
    return details ? postRequest<Config>('/admin/config/update', details.variables) : undefined;
  };

  return [updateInterviewQuestions, state];
};

export const useGetAccessTokenExpirationDate: BaseHookRequest<TokenExpiration, null> = params => {
  const [{ getRequest }, state] = useApi(params);
  const getAccessTokenExpirationDate = () =>
    getRequest<TokenExpiration>('/admin/config/access-token/status');
  return [getAccessTokenExpirationDate, state];
};

export const usePostRenewAccessToken: BaseHookRequest<string, TokenRenew> = params => {
  const [{ postRequest }, state] = useApi(params);

  const renewAccessToken: BaseRequest<TokenRenew> = details => {
    return details
      ? postRequest<TokenRenew>('/admin/config/access-token/renew', details.variables)
      : undefined;
  };
  return [renewAccessToken, state];
};
